var map = {
	"./airtel-zambia.jpeg": 1919,
	"./airtel-zm-od-and-micro-loans.jpeg": 1469,
	"./airtel-zm-od.jpeg": 9994,
	"./airtel-zm.jpeg": 6414,
	"./orange-project.jpeg": 7659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4725;